import { useIntl } from "react-intl";

const ServiceDependency = () => {
    const intl = useIntl();

    const messages = {
        header: intl.formatMessage({
            id: "JiraServiceManagementPricingPage.features.ServiceDependency.header",
            defaultMessage: "Service dependency"
        }),
        body: intl.formatMessage({
            id: "JiraServiceManagementPricingPage.features.ServiceDependency.body",
            defaultMessage:
                "Define the dependency or containment relationship to track the correlation status between services."
        })
    };

    return (
        <>
            <h2>{messages.header}</h2>
            <p>{messages.body}</p>
        </>
    );
};

export default ServiceDependency;
